export const preferredDistanceUnits = ['Imperial (Feet / Miles)', 'Metric (Meter / Kilometer)', 'UK'] as const
export const preferredEfficiencyUnits = ['km/kWh', 'kWh/km', 'kWh/mi', 'mi/kWh'] as const
export const preferredTemperatureUnits = ['celsius', 'fahrenheit'] as const
export type PreferredDistanceUnit = (typeof preferredDistanceUnits)[number]
export type PreferredEfficiencyUnit = (typeof preferredEfficiencyUnits)[number]
export type PreferredTemperatureUnit = (typeof preferredTemperatureUnits)[number]

export const preferredLanguages = ['en', 'fr', 'de'] as const
export type PreferredLanguage = (typeof preferredLanguages)[number]
